const initialState = {
  comparePortfolio: {
    yourDrilldown: [],
    yourChartOptions: [],
    iqcioDrilldown: [],
    iqcioChartOptions: [],
    yourTable: [],
    optimizedTable: [],
    tableHead: [],
  },
};

export default function compare(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);
  var cmp = newState.comparePortfolio;

  switch (type) {
    case "COMPARE_PORTFOLIO_TABLE_HEAD":
      cmp.tableHead = payload;
      break;

    case "SET_YOURTABLE_DATA":
      cmp.yourTable = payload;
      break;

    case "SET_IQTABLE_DATA":
      cmp.optimizedTable = payload;
      break;

    case "SET_YOURDRILLDOWN":
      cmp.yourDrilldown = payload;
      break;

    case "SET_IQDRILLDOWN":
      cmp.iqcioDrilldown = payload;
      break;

    case "SET_YR_CHARTOPTION":
      cmp.yourChartOptions = payload;
      break;

    case "SET_IQ_CHARTOPTION":
      cmp.iqcioChartOptions = payload;
      break;

    case "RESET_COMPARE_PORTFOLIO":
      cmp.yourDrilldown = [];
      cmp.yourChartOptions = [];
      cmp.iqcioDrilldown = [];
      cmp.iqcioChartOptions = [];
      cmp.yourTable = [];
      cmp.optimizedTable = [];
      cmp.tableHead = [];
      break;
    default:
      return state;
  }
  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/compare.reducer.js